// Retailer search URL builders. Plain search links (no affiliate tags yet) —
// affiliate parameters can be layered in later from settings.
const RETAILER_URLS = {
  Amazon: (q) => `https://www.amazon.com/s?k=${q}`,
  "Home Depot": (q) => `https://www.homedepot.com/s/${q}`,
  "Best Buy": (q) => `https://www.bestbuy.com/site/searchpage.jsp?st=${q}`,
  Staples: (q) => `https://www.staples.com/${q}/directory_${q}`,
  AutoZone: (q) => `https://www.autozone.com/searchresult?searchText=${q}`,
  Chewy: (q) => `https://www.chewy.com/s?query=${q}`,
  "Dick's Sporting Goods": (q) =>
    `https://www.dickssportinggoods.com/search/SearchDisplay?searchTerm=${q}`,
};

export const RETAILER_OPTIONS = Object.keys(RETAILER_URLS);

// Categories a Pro user can customize (Pharmacy/CVS removed). General is always Amazon.
export const PRO_CATEGORY_PRESETS = {
  General: "Amazon",
  Cooking: "Amazon",
  "Home Improvement": "Home Depot",
  Electronics: "Best Buy",
  Office: "Staples",
  Automotive: "AutoZone",
  Pets: "Chewy",
  Sports: "Dick's Sporting Goods",
};

export function storeForCategory(settings, category) {
  const cats = settings?.shop_categories || {};
  const entry = cats[category] || cats["General"] || { store: "Amazon", enabled: true };
  return entry;
}

export function buildShopUrl(store, supplies, tag) {
  const query = encodeURIComponent((supplies || []).slice(0, 8).join(" "));
  const builder = RETAILER_URLS[store] || RETAILER_URLS["Amazon"];
  return withTag(builder(query), store, tag);
}

export function buildItemUrl(store, queryText, tag) {
  const query = encodeURIComponent(queryText || "");
  const builder = RETAILER_URLS[store] || RETAILER_URLS["Amazon"];
  return withTag(builder(query), store, tag);
}

// Append the Amazon Associates tag to Amazon links only. No-op without a tag.
function withTag(url, store, tag) {
  const isAmazon = store === "Amazon" || !RETAILER_URLS[store];
  if (tag && isAmazon) {
    url += (url.includes("?") ? "&" : "?") + "tag=" + encodeURIComponent(tag);
  }
  return url;
}
